export default __webpack_public_path__ + "static/fall-59d79d754dfc06276554540f466354cf.jpg";